import { render, staticRenderFns } from "./inviteSettingDialog.vue?vue&type=template&id=a0385c7a&scoped=true"
import script from "./inviteSettingDialog.vue?vue&type=script&lang=js"
export * from "./inviteSettingDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteSettingDialog.vue?vue&type=style&index=0&id=a0385c7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0385c7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0385c7a')) {
      api.createRecord('a0385c7a', component.options)
    } else {
      api.reload('a0385c7a', component.options)
    }
    module.hot.accept("./inviteSettingDialog.vue?vue&type=template&id=a0385c7a&scoped=true", function () {
      api.rerender('a0385c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/printingPage/ozonPrint/components/inviteSettingDialog.vue"
export default component.exports